import { useEffect, useState } from "react";
import { BRAIN_API, getCsrfToken } from "../../lib/founderApi";

function meterColor(msLeft) {
  if (msLeft < 30 * 60000) return "#7A2E2E";
  if (msLeft < 2 * 3600000) return "#9B6B2F";
  return "#8A8378";
}

function meterLabel(msLeft) {
  const h = Math.floor(msLeft / 3600000);
  const m = Math.floor((msLeft % 3600000) / 60000);
  if (h >= 2) return `${h}h`;
  if (h >= 1) return `${h}h ${m}m`;
  return `${m}m`;
}

export function SessionMeter({ expiresAt }) {
  const [now, setNow] = useState(Date.now());
  const [sent, setSent] = useState(false);
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(id);
  }, []);
  if (!expiresAt) return null;

  const msLeft = new Date(expiresAt).getTime() - now;
  if (msLeft <= 0) return null;
  const color = meterColor(msLeft);

  const extend = async () => {
    const res = await fetch(`${BRAIN_API}/founder/extend`, {
      method: "POST",
      credentials: "include",
      headers: { "X-CSRF-Token": getCsrfToken() },
    });
    if (res.ok) setSent(true);
  };

  return (
    <p
      data-testid="session-expiry-indicator"
      className="text-xs mt-1 font-semibold"
      style={{ color }}
    >
      Session expires in {meterLabel(msLeft)} ·{" "}
      {sent ? (
        <span data-testid="session-extend-sent" className="text-[#0B3D5C]">
          link sent — check your inbox
        </span>
      ) : (
        <button
          data-testid="session-extend-btn"
          onClick={extend}
          className="underline"
          style={{ color }}
        >
          Extend
        </button>
      )}
    </p>
  );
}
